import React from 'react';
import { TransactionDetails } from '@/components/payments/transaction-details';
import { useRolePermissions } from '@/hooks/use-role-permissions';

export default function PaymentsTransactionDetailsPage() {
  const { canView } = useRolePermissions();
  const canViewPayments = canView('payments');
  
  if (!canViewPayments) {
    return <div className="p-6 text-center text-muted-foreground">You do not have permission to view payment transactions.</div>;
  }
  
  return (
    <div className="p-4 md:p-6">
      <TransactionDetails />
    </div>
  );
}


